// extracted by mini-css-extract-plugin
module.exports = {"hover_shadow_box":"HoverShadowBox-module--hover_shadow_box--1cbLj","hover_shadow_box_raise":"HoverShadowBox-module--hover_shadow_box_raise--29iNY"};